import { required } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      validationMessages: {},
    }
  },
  validations() {
    if (this.step === 1) {
      let rules = {
        form: {
          end_date: {
            required
          },
          start_date: {
            required
          },
          children_ages: {
            
          }
        }
      };

      if (this.form.type === this.$const('ConstReservationTypes', 'OPTION')) {
        rules.form = {...rules.form, expired_at: { required }};
      }

      return rules;
    } else {
      return {
        form: {
          property_id: {
            required
          },
          room_type_id: {
            required
          },
        }
      }
    }
  },
  methods: {
    setValidationMessage(attribute, rule) {
      if (this.$v.form[attribute]) {
        if (!this.$v.form[attribute][rule]) {
          this.validationMessages[attribute] = this.validationMessages[attribute] || [];
          this.validationMessages[attribute].push(this.$lang(`validation.${rule}`, {
            attribute: attribute
          }))
        }
      }
    },
    validate() {
      this.validationMessages = {};

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.setValidationMessage('end_date', 'required');
        this.setValidationMessage('start_date', 'required');
        this.setValidationMessage('expired_at', 'required');
        this.setValidationMessage('unit_id', 'required');
      }

      return this.$v.$invalid;
    }
  }
}
